import { Component } from '@verndale/core';
import $ from 'jquery';
import 'slick-carousel/slick/slick';

class Module extends Component {
  setupDefaults() {
    this.dom = {};

    this.initCarousel();
  }

  addListeners() {}

  // Code from the original MarineMax repo, just tweaked couple things
  initCarousel() {
    const $heroCarousels = $('section.image-gallery-masthead');
    if ($heroCarousels.length) {
      $heroCarousels.each((carouselindex, carouselEl) => {
        const $carouselEl = $(carouselEl);

        $carouselEl.find('.image-gallery-masthead__hero-images').each((imageIndex, heroImagesEl) => {
          const $heroImagesInstance = $(heroImagesEl);
          const slickInstance = $heroImagesInstance.slick({
            accessibility: false,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true,
            dots: true,
            prevArrow: `<button class="slick-prev" aria-label="Previous Image" title="Previous Image">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 21.5L27 10L21.375 21.5L27 33L18 21.5Z" fill="#0076a7"/>
                <circle cx="22" cy="22" r="21.5" stroke="#00416B"/>
                </svg>
              </span>`,
            nextArrow: `<button class="slick-next" aria-label="Next Image" title="Next Image">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27 21.5L18 10L23.625 21.5L18 33L27 21.5Z" fill="#0076a7"/>
                <circle cx="22" cy="22" r="21.5" stroke="#00416B"/>
                </svg>
              </span>`,
            appendArrows: '.slider-nav-container .slider-nav',
            appendDots: '.slider-nav-container .slider-nav'
          });

          // ada: toggle carousel play/pause
          const playPause = $('.image-gallery-masthead .image-gallery-masthead__toggle-carousel')
          playPause.on('click', (e) => {
              const pausedClass = 'paused'
              const paused = $heroImagesInstance.hasClass(pausedClass);

              if (paused) {
                slickInstance.slick('slickPlay');
                $heroImagesInstance.removeClass(pausedClass);
              } else {
                $heroImagesInstance.addClass(pausedClass);
                slickInstance.slick('slickPause');
              }

              playPause
                .each((i, el) => {
                  const $el = $(el);
                  let replaceText

                  if (!paused) {
                    replaceText = $el.data('playText');
                  } else {
                    replaceText = $el.data('pausedText');
                  }

                  if (replaceText) {
                    $el.text(replaceText);
                  }
                });
              e.stopPropagation();
            });
        });
      });
    }
  }
}

export default Module;
